import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import MaskedInput from 'react-maskedinput';
import RelationshipSelect from './relationship-select';
import RelationshipView from './relationship-view';
import { Checkbox } from '../';

export const FieldTypes = [
  'button',
  'checkbox',
  'color',
  'currency',
  'date',
  'datetime',
  'datetime-local',
  'email',
  'file',
  'files',
  'hidden',
  'image',
  'month',
  'number',
  'currency-usd',
  'phone',
  'radio',
  'range',
  'search',
  'tel',
  'text',
  'time',
  'url',
  'week',
  'textarea',
  'select',
  'multiselect',
  'relationship',
];

class Label extends React.Component {
  constructor(props) {
    super(props);

  }
  render() {
    return <label className={`ui-label ${this.props.className}`}>{this.props.text}</label>
  }
}

class Input extends React.Component {
  constructor(props) {
    super(props);

  }
  render() {
    const className = `ui-input ${this.props.className}`;
    const { type, onChange, placeholder, name, readOnly, value, id, label, returnSelectValueAsObject } = this.props;
    switch(this.props.type) {
      case 'textarea':
        return <div className="simple-compose-box">
          <textarea
            rows={this.props.rows}
            className="message-text"
            placeholder={this.props.placeholder}
            onChange={this.props.onChange}
            value={this.props.value}
          />
        </div>
      case 'select':
        return (
          <Select
            multi={false} {...this.props}
            onChange={value => {
              if(returnSelectValueAsObject) {
                this.props.onChange(value);
              }
              else {
                this.props.onChange(value ? value.value : '');
              }
            }}
            className={''}
            disabled={false}
          />
        )
      case 'multiselect':
        return (
          <div className='multi-select-container'>
            <Select
              multi={true}
              {...this.props}
              onChange={values => {
                if(returnSelectValueAsObject) {
                  this.props.onChange(values);
                }
                else {
                  this.props.onChange(values.map( ({value}) => value));
                }
              }}
              className={''}
              disabled={false}
            />
          </div>
        )
      case 'phone':
        let masked_input_props = {...this.props};
        delete masked_input_props.fileLimit;
        delete masked_input_props.entity_ref;
        delete masked_input_props.options;
        return (
          <MaskedInput
            {...masked_input_props}
            value={String(value)}
            mask={'(111) 111-1111'}
          />
        )
      case 'relationship':
        return (
          <RelationshipSelect
            {...this.props}
            onChange={data => {this.props.onChange(data ? data.value : '')}}
          />
        )
      case 'checkbox':
        return (
          <Checkbox
            id={`${name}-custom-checkbox-id`}
            onChange={onChange}
            checked={value != null ? value : false}
            className={className || 'custom-field-checkbox'}
            label={label}
            readOnly={readOnly}
          />
        )
        break;
      case 'currency':
      case 'button':
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'email':
      case 'file':
      case 'files':
      case 'hidden':
      case 'image':
      case 'month':
      case 'number':
      case 'radio':
      case 'range':
      case 'search':
      case 'tel':
      case 'text':
      case 'time':
      case 'url':
      case 'week':
      default:
        return (
          <input
            className={className}
            type={!type ? 'text' : type}
            onChange={onChange}
            placeholder={placeholder}
            name={name}
            readOnly={readOnly}
            value={value}
          />
        )
    }
  }
}

Input.propTypes = {
  type : PropTypes.oneOf(FieldTypes),
}

class Output extends React.Component {
  static propTypes = {
    type : PropTypes.oneOf(FieldTypes),
  }
  render() {
    const { value } = this.props;
    switch(this.props.type) {
      case 'relationship':
        return <RelationshipView {...this.props} />
      case 'checkbox':

      default:
      return (
        <div className="form-control-static text-muted">
          {typeof value === 'number'? value.toLocaleString() : !value ? 'None provided.' : typeof value === 'string' ? value : '' || value.constructor.name === 'Array' ? value.join(', ') || 'None selected.' : '' || 'None Provided.'}
        </div>
      );
    }
  }
}

class Field extends React.Component {
  static propTypes = {
    name : PropTypes.string.isRequired,
    label : PropTypes.string,
    type : PropTypes.oneOf(FieldTypes),
    options : PropTypes.arrayOf(PropTypes.shape({
      label : PropTypes.string.isRequired,
      value : PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })),
    fileLimit : PropTypes.number,
    onChange : PropTypes.func,
    disabled : PropTypes.bool,
  }
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }
  /** Takes the event and normalizes a value from it and hands that value back to onChange */
  handleInputChange(event, type, name) {
    if(!this.props.onChange) {
      return;
    }

    let value;

    switch(type) {
      case 'select': case 'multiselect': case 'relationship':
        value = event;
        break;
      case 'checkbox':
        value = event.target.checked;
        break;
      default:
        value = event.target.value;
        break;
    }

    this.props.onChange(value, type);
  }
  render() {
    const {
      label,
      type,
      options,
      placeholder,
      className,
      disabled,
      fileLimit,
      name,
      value,
      onChange,
      returnSelectValueAsObject,
      readOnly,
      entity_ref,
    } = this.props;

    return (
      type == 'checkbox' ? (
        <Input
          className={className || 'form-control'}
          disabled={disabled}
          placeholder={placeholder}
          name={name}
          type={type}
          options={options}
          fileLimit={fileLimit}
          value={value}
          entity_ref={entity_ref}
          label={label}
          onChange={event => this.handleInputChange(event, type, name)}
          readOnly={readOnly}
        />
      ) : (
        <div className={`ui-field${readOnly ? ' read-only' : ''}`}>
          {label ? <Label className={`control-label${readOnly ? ' text-dark' : ''}`} text={label} /> : null}
            {!readOnly ? <Input
              className={className || 'form-control'}
              disabled={disabled}
              placeholder={placeholder}
              name={name}
              type={type}
              options={options}
              fileLimit={fileLimit}
              value={value}
              entity_ref={entity_ref}
              onChange={event => this.handleInputChange(event, type, name)}
              returnSelectValueAsObject={returnSelectValueAsObject}
            />
            : <Output {...this.props} />}
        </div>
      )
    )
  }
}

export default Field;



// WEBPACK FOOTER //
// ./src/browser/components/form-builder/field.js